import { combineReducers } from 'redux';
import { decorateJsonApiReducerForSiteConfig } from './site-config-hack.reducer';

// Reducers
import { router } from 'redux-ui-router';
import { reducer as error } from './error';
import { jsonApi, pending } from './http-request';
import { reducer as homeServices } from './home-services';
import { reducer as name } from './name';
import { reducer as session } from './session';
import { reducer as signUp } from './sign-up';
import { reducer as movingCenter } from './moving-center';
import { reducer as siteConfig } from './site-config';
import { reducer as step } from './step';
import { reducer as promotions } from './promotions';
import { reducer as contentful } from './contentful';
import { reducer as experiments } from './experiments';
import { reducer as moveiq } from './moveiq';
import { reducer as insurance } from './insurance';

export const RootReducer = combineReducers({
  contentful,
  error,
  jsonApi: decorateJsonApiReducerForSiteConfig(jsonApi.reducer),
  homeServices,
  insurance,
  movingCenter,
  moveiq,
  name,
  experiments,
  pending: pending.reducer,
  promotions,
  session,
  signUp,
  siteConfig,
  step,
  router,
});
